import makeStyles from "@material-ui/core/styles/makeStyles";
import { createStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    titleBar: {
      textAlign: "start",
      backgroundColor: "#869ac4"
    }
  })
);
